"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.DIVIDER_CSS_VARIABLES = void 0;
var _tss = require("../styles/tss");
var _generateCssVariables = require("../utilities/CssVariables/generateCssVariables");
const DIVIDER_CSS_VARIABLES = exports.DIVIDER_CSS_VARIABLES = (0, _generateCssVariables.generateCssVariables)('Divider', ['color', 'rounding', 'thickness']);
const useStyles = exports.useStyles = _tss.tss.create(() => {
  return {
    root: {
      // Resets browser default styles
      border: 0,
      margin: 0,
      borderRadius: `var(${DIVIDER_CSS_VARIABLES.rounding})`,
      backgroundColor: `var(${DIVIDER_CSS_VARIABLES.color})`
    },
    orientationHorizontal: {
      height: `var(${DIVIDER_CSS_VARIABLES.thickness})`
    },
    orientationVertical: {
      width: `var(${DIVIDER_CSS_VARIABLES.thickness})`
    }
  };
});